<template>
  <ComingConsultationsPage method="session" />
</template>

<script setup>
import ComingConsultationsPage from "./ComingConsultationsPage.vue";
</script>
